import { render, staticRenderFns } from "./GesPostulante.vue?vue&type=template&id=4a765654&scoped=true&"
import script from "./GesPostulante.vue?vue&type=script&lang=js&"
export * from "./GesPostulante.vue?vue&type=script&lang=js&"
import style0 from "./GesPostulante.vue?vue&type=style&index=0&id=4a765654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a765654",
  null
  
)

export default component.exports